<div class="row">
  <div class="col-xl-9">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between border-bottom">
          <p>Custom Deductions Description</p>
          <div class="d-flex align-items-center">
            <!-- <label class="col-form-label">Business:&nbsp; </label> -->
            <select class="form-select" (change)="onBusinessSelect($event)">
              <option selected value="">Select Business Entity</option>
              <option *ngFor="let item of businessesList" [value]="item.id">
                {{ item.businessName | capitalize }}
              </option>
            </select>
          </div>
        </div>
        <div class="content">
          <div class="tab-content custom-accordion-items">
            <div class="tab-pane active show" id="bottom-justified-tab1" role="tabpanel">
              <div class="accordion accordions-items-seperate" id="accordionExample">
                <div class="accordion-item">
                  <div class="accordion-header" id="headingOne">
                    <div class="accordion-button">
                      <div class="d-flex align-items-center flex-fill justify-content-between">
                        <h5>Pre-Tax Deductions</h5>
                        <a
                          href="#"
                          class="d-flex align-items-end collapse-arrow"
                          data-bs-toggle="collapse"
                          data-bs-target="#primaryBorderOne"
                          aria-expanded="true"
                          aria-controls="primaryBorderOne"
                        >
                          <i class="ti ti-chevron-down fs-18"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    id="primaryBorderOne"
                    class="accordion-collapse collapse show border-top"
                    aria-labelledby="headingOne"
                  >
                    <div class="accordion-body mt-2">
                      <table class="table datatable">
                        <thead class="thead-light">
                          <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Business Entity</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of customDeductions$ | async">
                            <ng-container *ngIf="item.info.taxable">
                              <td>{{ item.name }}</td>
                              <td style="word-wrap: break-word; white-space: normal">
                                {{ item.description }}
                              </td>
                              <td>
                                <div *ngIf="businesses$ | async as businesses">
                                  <ng-container *ngFor="let business of businesses">
                                    <ng-container *ngIf="item.belongsTo === business.id">
                                      {{ business.businessName }}
                                    </ng-container>
                                  </ng-container>
                                </div>
                              </td>
                              <td>
                                <div class="action-icon d-inline-flex">
                                  <a
                                    href="javascript:void(0);"
                                    (click)="openEditModal(addEarningModal, item)"
                                    *appHasPermission="{ customDeductions: ['edit'] }"
                                    ><i class="ti ti-edit"></i
                                  ></a>
                                  <a
                                    href="javascript:void(0);"
                                    (click)="openDeleteModal(deleteModal, item)"
                                    *appHasPermission="{ customDeductions: ['delete'] }"
                                    ><i class="ti ti-trash"></i
                                  ></a>
                                </div>
                              </td>
                            </ng-container>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <div class="accordion-header" id="headingAdditionalInfo">
                    <div class="accordion-button">
                      <div class="d-flex align-items-center flex-fill justify-content-between">
                        <h5>Post-Tax Deductions</h5>
                        <a
                          href="#"
                          class="d-flex align-items-end collapsed collapse-arrow"
                          data-bs-toggle="collapse"
                          data-bs-target="#primaryBorderOneAdditionalInfo"
                          aria-expanded="false"
                          aria-controls="primaryBorderOneAdditionalInfo"
                        >
                          <i class="ti ti-chevron-down fs-18"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    id="primaryBorderOneAdditionalInfo"
                    class="accordion-collapse collapse border-top"
                    aria-labelledby="headingAdditionalInfo"
                  >
                    <div class="accordion-body mt-2">
                      <table class="table datatable">
                        <thead class="thead-light">
                          <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Business Entity</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of customDeductions$ | async">
                            <ng-container *ngIf="!item.info.taxable">
                              <td>{{ item.name }}</td>
                              <td style="word-wrap: break-word; white-space: normal">
                                {{ item.description }}
                              </td>
                              <td>
                                <div *ngIf="businesses$ | async as businesses">
                                  <ng-container *ngFor="let business of businesses">
                                    <ng-container *ngIf="item.belongsTo === business.id">
                                      {{ business.businessName }}
                                    </ng-container>
                                  </ng-container>
                                </div>
                              </td>
                              <td>
                                <div class="action-icon d-inline-flex">
                                  <a
                                    href="javascript:void(0);"
                                    (click)="openEditModal(addEarningModal, item)"
                                    *appHasPermission="{ customDeductions: ['edit'] }"
                                    ><i class="ti ti-edit"></i
                                  ></a>
                                  <a
                                    href="javascript:void(0);"
                                    (click)="openDeleteModal(deleteModal, item)"
                                    *appHasPermission="{ customDeductions: ['delete'] }"
                                    ><i class="ti ti-trash"></i
                                  ></a>
                                </div>
                              </td>
                            </ng-container>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xl-3 theiaStickySidebar" *appHasPermission="{ customDeductions: ['add'] }">
    <div class="card">
      <div class="card-body">
        <!-- <div class="d-flex flex-column list-group settings-list"> -->
        <div class="d-grid">
          <button (click)="openModel(addEarningModal)" class="btn btn-primary" type="button">
            + New Deduction
          </button>
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>

<!-- models -->
<!-- Add Earning Modal -->
<ng-template #addEarningModal let-modal>
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">{{ this.operation === 'Edit' ? 'Edit' : 'Add New' }} Deduction</h5>
    <button type="button" class="btn-close custom-btn-close" aria-label="Close" (click)="onClose()">
      <i class="ti ti-x"></i>
    </button>
  </div>

  <div class="modal-body m-2">
    <form [formGroup]="form">
      <div class="my-4">
        <label for="select-business" class="form-label"
          >Business Entity Name <span class="text-danger">*</span></label
        >
        <select id="select-business" class="form-select" formControlName="belongsTo">
          <!-- <option  disabled selected>Select Business</option> -->
          <option *ngFor="let item of businessesList" [value]="item.id">
            {{ item.businessName | capitalize }}
          </option>
        </select>

        <div *ngIf="form.get('belongsTo')?.errors?.['required']">
          <span class="text-danger">
            {{ getErrorMessage('belongsTo') }}
          </span>
        </div>
      </div>
      <div id="first-field">
        <div class="row earning-row">
          <div>
            <label for="name" class="form-label"
              >Deduction Name <span class="text-danger">*</span></label
            >
            <input id="name" type="text" class="form-control" formControlName="name" />
            <div *ngIf="form.get('name')?.errors?.['required']">
              <span class="text-danger">
                {{ getErrorMessage('name') }}
              </span>
            </div>
          </div>
          <div>
            <label for="description" class="form-label">Description</label>
            <textarea
              id="description"
              class="form-control"
              formControlName="description"
              maxlength="255"
            ></textarea>
          </div>
        </div>
        <div class="my-4" formGroupName="info">
          <label for="deductionPlan" class="form-label"
            >Deduction Plan <span class="text-danger">*</span></label
          >
          <select id="deductionPlan" class="form-select" formControlName="deductionPlan">
            <!-- <option  disabled selected>Select Business</option> -->
            <option value="nps">National Pension Scheme</option>
            <option value="vpf">Voluntary Provident Fund</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div class="my-4" formGroupName="info">
          <label class="form-label" for="calculationType">Calculation Type</label>

          <select class="form-select" formControlName="calculationType">
            <option value="flatAmount" selected>Flat Amount</option>
            <option value="percentage">Percentage</option>
            <!-- <option value="proRata">Pro-rata</option> -->
          </select>
        </div>
        <div class="my-4" formGroupName="info">
          <div class="form-check form-switch">
            <input
              appTrimInput
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="isInctc"
              formControlName="isInCTC"
            />
            <label class="form-check-label" for="isInctc">Employer's contribution in CTC</label>
          </div>
        </div>
        <div class="my-4" formGroupName="info">
          <div class="form-check form-switch">
            <input
              appTrimInput
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="proRataBasis"
              formControlName="proRataBasis"
            />
            <label class="form-check-label" for="proRataBasis">Calculation pro-rata basis</label>
          </div>
        </div>
        <div class="my-4" formGroupName="info">
          <label for="deductionType" class="form-label">Deduction Type</label>
          <div class="form-check">
            <input
              appTrimInput
              class="form-check-input"
              type="radio"
              id="preTaxDeduction"
              [value]="true"
              formControlName="taxable"
            />
            <label class="form-check-label" for="preTaxDeduction"> Pre-Tax Deduction </label>
          </div>
          <div class="form-check">
            <input
              appTrimInput
              class="form-check-input"
              type="radio"
              id="postTaxDeduction"
              [value]="false"
              formControlName="taxable"
            />
            <label class="form-check-label" for="postTaxDeduction"> Post-Tax Deduction </label>
          </div>
        </div>
        <div class="col-lg-12 text-end form-wizard-button">
          <button
            type="button"
            (click)="sendDataToParent()"
            [disabled]="!form.get('name')?.valid || !form.get('belongsTo')?.valid"
            class="btn btn-primary wizard-next-btn"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
<!-- /Add Termination -->

<!-- Delete Modal -->
<ng-template #deleteModal let-modal>
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Delete</h4>
    <p class="mb-3">You want to delete the entry, this can't be undone once you delete.</p>
    <div class="d-flex justify-content-center">
      <a
        href="javascript:void(0);"
        class="btn btn-light me-3"
        data-bs-dismiss="modal"
        (click)="onClose()"
        >Cancel</a
      >
      <a href="javascript:void(0);" class="btn btn-danger" (click)="sendDataToParent()"
        >Yes, Delete</a
      >
    </div>
  </div>
</ng-template>
<!-- /Delete Modal -->
